class AddToCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onAdd);
  }
  onAdd() {
    this.classList.add('loading');
    var variantId = this.getAttribute('data-variant-id');
    var quantity = this.getAttribute('data-quantity');
    const cartDrawer = document.querySelector('cart-drawer');

    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity ? quantity : 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.classList.remove('loading');
        const cartBtn = this;
        if (cartItems) {
          cartItems.onCartUpdate();
        }
        if (cartDrawer) {
          cartDrawer.setHeaderCartIconAccessibility();
          cartDrawer.open();
        }

        fetch('/cart.js')
          .then((response) => response.json())
          .then((data) => {

            const icon = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 3.75L6.875 3.75L7.5 6.25M7.5 6.25L10 16.25M7.5 6.25H26.25L23.75 16.25H10M10 16.25H9.375C8.33947 16.25 7.5 17.0895 7.5 18.125C7.5 19.1605 8.33947 20 9.375 20H23.75M23.75 25C23.75 25.6904 23.1904 26.25 22.5 26.25C21.8096 26.25 21.25 25.6904 21.25 25C21.25 24.3096 21.8096 23.75 22.5 23.75C23.1904 23.75 23.75 24.3096 23.75 25ZM11.25 25C11.25 25.6904 10.6904 26.25 10 26.25C9.30964 26.25 8.75 25.6904 8.75 25C8.75 24.3096 9.30964 23.75 10 23.75C10.6904 23.75 11.25 24.3096 11.25 25Z" stroke="black" stroke-width="1.25" stroke-linecap="round"/>
            </svg>
                <span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">${data.item_count}</span><span class="visually-hidden">${data.item_count} item</span></div>`;

          const icon2 = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 3.75L6.875 3.75L7.5 6.25M7.5 6.25L10 16.25M7.5 6.25H26.25L23.75 16.25H10M10 16.25H9.375C8.33947 16.25 7.5 17.0895 7.5 18.125C7.5 19.1605 8.33947 20 9.375 20H23.75M23.75 25C23.75 25.6904 23.1904 26.25 22.5 26.25C21.8096 26.25 21.25 25.6904 21.25 25C21.25 24.3096 21.8096 23.75 22.5 23.75C23.1904 23.75 23.75 24.3096 23.75 25ZM11.25 25C11.25 25.6904 10.6904 26.25 10 26.25C9.30964 26.25 8.75 25.6904 8.75 25C8.75 24.3096 9.30964 23.75 10 23.75C10.6904 23.75 11.25 24.3096 11.25 25Z" stroke="black" stroke-width="1.25" stroke-linecap="round"/>
            </svg>
                <span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">${data.item_count}</span><span class="visually-hidden">${data.item_count} item</span></div>
                `;

            if(document.querySelector('#cart-icon-bubble')){
              document.querySelector(
                '#cart-icon-bubble'
              ).innerHTML = icon;
            }
            if(document.querySelector('#cart-icon-bubble-mobile')){
              document.querySelector(
                '#cart-icon-bubble-mobile'
              ).innerHTML = icon;
            }
            if(document.querySelector('#cart-icon-bubble-info')){
              document.querySelector(
                '#cart-icon-bubble-info'
              ).innerHTML = icon2;
            }
            // handleModal();
            // handleTermCheckbox();
            
          })
          .catch((error) => console.error('Error fetching cart data:', error));
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}
customElements.define('add-to-cart', AddToCart);
